import { Box } from '@mui/material';

import { ReactComponent as ThumbupFill } from 'common/assets/images/thumbup-fill.svg';
import { ReactComponent as Thumbup } from 'common/assets/images/thumbup.svg';

import { IFeedbackProps } from 'features/OpenRiskGPT/api/type-def';

import styles from './FeedbackIconDisplay.module.scss';

interface IRiskGptFeedBackDisplay {
	previousFeedBack: IFeedbackProps;
	currentFeedBack: IFeedbackProps;
	clickLikeFeedBack: any;
	clickUnLikeFeedBack: any;
	disabled?: boolean;
}
const FeedbackDisplay = (props: any) => {
	const { clickEvent, rotate, disabled } = props;
	return (
		<Box
			className={`${styles['risk-gpt-thumbup']} ${
				disabled
					? styles['risk-gpt-thumbup-disabled']
					: styles['risk-gpt-thumbup-enabled']
			}`}
			onClick={disabled ? undefined : (e) => clickEvent(e)}
			data-testid="like-feedback"
		>
			<Thumbup
				className={`${
					styles[`risk-gpt-${rotate ? 'thumbup' : 'thumbdown'}-icon`]
				} ${
					disabled
						? styles['risk-gpt-thumbup-disabled']
						: styles['risk-gpt-thumbup-enabled']
				}`}
			/>
		</Box>
	);
};

const FeedbackFillDisplay = (props: any) => {
	const { clickEvent, rotate, disabled } = props;
	return (
		<Box
			className={`${styles['risk-gpt-thumbup']} ${
				disabled
					? styles['risk-gpt-thumbup-disabled']
					: styles['risk-gpt-thumbup-enabled']
			}`}
			onClick={disabled ? undefined : (e) => clickEvent(e)}
			data-testid="like-feedback"
		>
			<ThumbupFill
				className={`${
					styles[`risk-gpt-${rotate ? 'thumbup' : 'thumbdown'}-icon`]
				} ${
					disabled
						? styles['risk-gpt-thumbup-disabled']
						: styles['risk-gpt-thumbup-enabled']
				}`}
			/>
		</Box>
	);
};

const FeedbackIconDisplay = (props: IRiskGptFeedBackDisplay) => {
	const {
		previousFeedBack,
		currentFeedBack,
		clickLikeFeedBack,
		clickUnLikeFeedBack,
		disabled,
	} = props;
	const handleClickLike = (e: React.MouseEvent) => {
		if (!disabled) {
			clickLikeFeedBack(e);
		}
	};

	const handleClickUnLike = (e: React.MouseEvent) => {
		if (!disabled) {
			clickUnLikeFeedBack(e);
		}
	};

	if (previousFeedBack?.isLike === undefined)
		return (
			<>
				<FeedbackDisplay
					clickEvent={handleClickLike}
					rotate
					isFilled={false}
					disabled={disabled}
				/>
				<FeedbackDisplay
					clickEvent={handleClickUnLike}
					rotate={false}
					isFilled={false}
					disabled={disabled}
				/>
			</>
		);
	else if (!previousFeedBack.id)
		return (
			<>
				{previousFeedBack.isLike && (
					<>
						<FeedbackFillDisplay
							clickEvent={handleClickLike}
							rotate
							disabled={disabled}
						/>
						<FeedbackDisplay
							clickEvent={handleClickUnLike}
							rotate={false}
							disabled={disabled}
						/>
					</>
				)}
				{!previousFeedBack.isLike && (
					<>
						<FeedbackDisplay
							clickEvent={handleClickLike}
							rotate
							disabled={disabled}
						/>
						<FeedbackFillDisplay
							clickEvent={handleClickUnLike}
							rotate={false}
							disabled={disabled}
						/>
					</>
				)}
			</>
		);
	else if (previousFeedBack.isLike)
		return (
			<div className={styles['chat-feedback-grid']}>
				{currentFeedBack?.isLike === undefined ? (
					<>
						<ThumbupFill className={styles['risk-gpt-thumbup-fill-icon']} />
						<FeedbackDisplay
							clickEvent={handleClickUnLike}
							rotate={false}
							disabled={disabled}
						/>
					</>
				) : (
					<>
						<Thumbup className={styles['risk-gpt-thumbup-fill-icon']} />
						<FeedbackFillDisplay
							clickEvent={handleClickUnLike}
							rotate={false}
							disabled={disabled}
						/>
					</>
				)}
			</div>
		);
	/// for unlike senario
	return (
		<div className={styles['chat-feedback-grid']}>
			{currentFeedBack?.isLike === undefined ? (
				<>
					<FeedbackDisplay
						clickEvent={handleClickLike}
						rotate
						disabled={disabled}
					/>
					<ThumbupFill className={styles['risk-gpt-thumbdown-fill-icon']} />
				</>
			) : (
				<>
					<FeedbackFillDisplay
						clickEvent={handleClickLike}
						rotate
						disabled={disabled}
					/>
					<Thumbup className={styles['risk-gpt-thumbdown-fill-icon']} />
				</>
			)}
		</div>
	);
};

export default FeedbackIconDisplay;
